import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { zAppDevGridComponent } from './Grid.component';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { zAppDevIconismModule } from '../Iconism/iconism.module';
import { zAppDevButtonModule } from '../Button/button.module';
import { RuleEngineModule } from '../../rule-engine/rule-engine.module';
import { TranslateModule } from '@ngx-translate/core';


const DATATABLE_COMPONENTS = [zAppDevGridComponent];
const DATATABLE_PROVIDERS = [];


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        TranslateModule,
        TableModule,
        InputTextModule,
        ButtonModule,
        RuleEngineModule,
        zAppDevIconismModule,
        zAppDevButtonModule,
        ...DATATABLE_COMPONENTS
    ],
    exports: [...DATATABLE_COMPONENTS],
})
export class zAppDevGridModule {
    static forRoot(): ModuleWithProviders<zAppDevGridModule> {
        return {
            ngModule: zAppDevGridModule,
            providers: [
                ...DATATABLE_PROVIDERS
            ],
        };
    }
}
